import css from 'styled-jsx/css';
import { colors } from '../../../config/styles';

const DrawerTabStyles = css`
  iframe.sizechart-template {
    width: 100%;
    height: inherit;
  }

  @media (min-width: 1024px) {
    iframe.sizechart-template {
      display: block;
      min-width: 400px;
      max-width: 760px;
    }
  }

  .sizechart-container {
    width: 100%;
    height: 80vh;
  }

  .drawer-tab-content {
    width: 100%;
    height: 100vh;
  }

  :global(.drawer-container.secondary.auto-height.size-chart-drawer) .drawer-tab-content {
    width: 100%;
    height: auto;
    transition: height 0.3s ease-in-out, opacity 0.2s ease-in-out;
  }

  .drawer-tab {
    width: 100%;
  }

  .drawer-tab ul {
    margin: auto;
    padding: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .drawer-tab ul li {
    flex: 1;
    width: 100%;
  }

  .drawer-tab .tab-button {
    background-color: ${colors.gray.shade6};
    height: 42px;
    width: 100%;
    font: 14px 'Lato', sans-serif;
    line-height: 15px;
    font-weight: bold;
    letter-spacing: 0.933333px;
    color: ${colors.black.shade1};
  }

  .drawer-tab .tab-active {
    border-top: 2px solid ${colors.blue.shade3};
    background-color: ${colors.white.shade1};
    height: 42px;
    width: 100%;
    font: 14px 'Lato', sans-serif;
    line-height: 15px;
    font-weight: bold;
    letter-spacing: 0.933333px;
    color: ${colors.black.shade1};
  }

  .drawer-tab .tab-active:disabled {
    color: ${colors.black.shade1};
    font-weight: bold;
  }

  .size-chart-table-container {
    padding: 20px;
    width: 100%;
    max-width: 100%;
  }

  .size-chart-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
    max-width: 760px;
    margin: 0 auto 20px;
    gap: 0;
    border: 1px solid ${colors.gray.shade6};
    border-radius: 4px;
    overflow: hidden;
  }

  .grid-header {
    background-color: ${colors.gray.shade6};
    padding: 16px 12px;
    text-align: center;
    font-family: 'Lato', sans-serif;
    font-size: 16px;
    font-weight: bold;
    color: ${colors.black.shade1};
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 2px solid ${colors.white.shade1};
  }

  .grid-cell {
    padding: 16px 12px;
    text-align: center;
    font-family: 'Lato', sans-serif;
    font-size: 15px;
    color: ${colors.black.shade1};
    background-color: ${colors.white.shade1};
    border-bottom: 1px solid ${colors.gray.shade6};
    border-right: 1px solid ${colors.gray.shade6};
  }

  .grid-header.active-column {
    background-color: ${colors.gray.shade6};
    font-weight: 600;
  }

  .grid-cell.active-column {
    background-color: ${colors.gray.shade6};
    font-weight: 600;
  }

  .size-chart-help-text {
    display: flex;
    flex-direction: column;
    font-family: 'Lato', sans-serif;
    font-size: 14px;
    line-height: 20px;
    color: ${colors.gray.shade2};
    text-align: left;
    margin: 20px 0;
    padding: 0 20px;
    max-width: 760px;
    margin-left: auto;
    margin-right: auto;
  }

  .help-text-title {
    width: 100%;
    font-weight: bold;
    margin-bottom: 8px;
  }

  .help-text-detail {
    width: 100%;
    font-weight: normal;
  }

  @media (max-width: 768px) {
    .size-chart-table-container {
      padding: 12px;
    }

    .size-chart-grid {
      grid-template-columns: repeat(auto-fit, minmax(60px, 1fr));
    }

    .grid-header {
      padding: 12px 8px;
      font-size: 14px;
    }

    .grid-cell {
      padding: 12px 8px;
      font-size: 13px;
    }

    .size-chart-help-text {
      font-size: 13px;
      padding: 0 12px;
    }
  }

  @media (max-width: 480px) {
    .size-chart-grid {
      grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));
    }

    .grid-header {
      padding: 10px 6px;
      font-size: 12px;
    }

    .grid-cell {
      padding: 10px 6px;
      font-size: 12px;
    }
  }
`;

export { DrawerTabStyles };
